import { Application } from 'feathers';
import registration from './Registration';

export default (app: Application) => {
  app.configure(registration(app));
};


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/apps/BCOMS/services/index.ts